import { CmsWebsiteBM, CustomerBM, WebsiteFM } from '@bm-js/atlascloud-shared'
import { createContext } from 'react'

type AppState = {
  customer: CustomerBM | null
  atlasWebsite: WebsiteFM | null
  cmsWebsite: CmsWebsiteBM | null
  anyWebsite: WebsiteFM | CmsWebsiteBM | null
  refetchAtlasWebsite: () => Promise<void>
  refetchCmsWebsite: () => Promise<void>
}

const initialAppState: AppState = {
  customer: null,
  atlasWebsite: null,
  cmsWebsite: null,
  anyWebsite: null,
  refetchAtlasWebsite: async () => {},
  refetchCmsWebsite: async () => {},
}

export const AppContext = createContext<AppState>(initialAppState)
